import React from 'react';
import Paper, { PaperProps } from '@material-ui/core/Paper';
import Draggable, { ControlPosition, DraggableData, DraggableEvent, DraggableEventHandler } from 'react-draggable';

// import './DialogPaperComponent.less'

export interface IDialogPaperResizeProps {
  onDragStart: DraggableEventHandler;
  onDrag: DraggableEventHandler;
  onDragStop: DraggableEventHandler;
  draggableId: React.MutableRefObject<string>;
  dragPosition: React.MutableRefObject<ControlPosition>;
}

interface IDialogPaperComponentProps extends Omit<PaperProps, 'onDrag' | 'onDragStart'>, IDialogPaperResizeProps {
  children?: React.ReactNode;
}

/**
 * Originally an inline paper declaration using useCallback to memoize drag handlers,
 * this can be its own component and let React manage it (to preserve dialog children
 * when toggling full screen) because we can merge our drag props using Dialog.PaperProps.
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function DialogPaperComponent({
  draggableId,
  dragPosition,
  onDragStart,
  onDrag,
  onDragStop,
  ...paperProps
}: IDialogPaperComponentProps) {
  return (
    <Draggable
      handle={`#${draggableId.current}`}
      onStart={onDragStart}
      onDrag={(e: DraggableEvent, data: DraggableData) => {
        // notify parent of last drag position on stop:
        dragPosition.current = { x: data.x, y: data.y };
        onDrag?.(e, data);
      }}
      onStop={onDragStop}
      bounds="parent"
      cancel={'[class*="MuiDialogContent-root"], .dp-dialog-title-actions__button'}
    >
      <Paper {...paperProps} />
    </Draggable>
  );
}
